<template>
  <div class="dashboard-container">
     <div class="scroll-container">
    <el-row :gutter="20" class="scroll-row">
      <!-- 统计卡片 -->
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="stat-info">
              <div class="stat-title">{{ $t('dashboard.totalMembers') }}</div>
              <div class="stat-value">{{ dashboardData.memberStats?.totalMembers || 0 }}</div>
              <div class="stat-desc">{{ $t('dashboard.comparedToLastMonth') }} {{ newMembersPercent }}%</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="stat-info">
              <div class="stat-title">{{ $t('dashboard.totalBookings') }}</div>
              <div class="stat-value">{{ dashboardData.courseStats?.totalBookings || 0 }}</div>
              <div class="stat-desc">{{ $t('dashboard.averageBookingRate') }} {{ (dashboardData.courseStats?.avgBookingRate * 100).toFixed(2) }}%</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-collection"></i>
            </div>
            <div class="stat-info">
              <div class="stat-title">{{ $t('dashboard.totalCourses') }}</div>
              <div class="stat-value">{{ dashboardData.courseStats?.totalCourses || 0 }}</div>
              <div class="stat-desc">{{ $t('dashboard.courseTypes') }} {{ dashboardData.courseStats?.courseTypeDistribution?.length || 0 }} 种</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-money"></i>
            </div>
            <div class="stat-info">
              <div class="stat-title">{{ $t('dashboard.monthlyIncome') }}</div>
              <div class="stat-value">¥ {{ formatCurrency(dashboardData.financeStats?.totalIncome) }}</div>
              <div class="stat-desc">{{ $t('dashboard.comparedToLastMonth') }} {{ incomeChangePercent }}%</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    </div>

    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ $t('dashboard.coachDailyBookings') }}</span>
          </div>
          <div class="chart-container">
            <div ref="coachBookingChart" style="width: 100%; height: 300px;"></div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ $t('dashboard.weeklyProjectRevenue') }}</span>
          </div>
          <div class="chart-container">
            <div ref="projectRevenueChart" style="width: 100%; height: 300px;"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px;">
      <!-- 会员增长趋势图 -->
      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ $t('dashboard.memberGrowthTrend') }}</span>
            <el-radio-group v-model="memberGrowthPeriod" size="mini" style="float: right;">
              <el-radio-button label="week">{{ $t('dashboard.week') }}</el-radio-button>
              <el-radio-button label="month">{{ $t('dashboard.month') }}</el-radio-button>
            </el-radio-group>
          </div>
          <div class="chart-container">
            <div ref="memberGrowthChart" style="width: 100%; height: 300px;"></div>
          </div>
        </el-card>
      </el-col>
      <!-- 预约量趋势图 -->
      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ $t('dashboard.bookingTrend') }}</span>
            <el-radio-group v-model="bookingTrendPeriod" size="mini" style="float: right;">
              <el-radio-button label="day">{{ $t('dashboard.day') }}</el-radio-button>
              <el-radio-button label="week">{{ $t('dashboard.week') }}</el-radio-button>
              <el-radio-button label="month">{{ $t('dashboard.month') }}</el-radio-button>
            </el-radio-group>
          </div>
          <div class="chart-container">
            <div ref="bookingTrendChart" style="width: 100%; height: 300px;"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px;">
      <!-- 会员活跃度分布 -->
      <el-col :span="8">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ $t('dashboard.memberActivityDistribution') }}</span>
            <el-radio-group v-model="activityPeriod" size="mini" style="float: right;">
              <el-radio-button label="week">{{ $t('dashboard.week') }}</el-radio-button>
              <el-radio-button label="month">{{ $t('dashboard.month') }}</el-radio-button>
              <el-radio-button label="year">{{ $t('dashboard.year') }}</el-radio-button>
            </el-radio-group>
          </div>
          <div class="chart-container">
            <div ref="memberActivityChart" style="width: 100%; height: 300px;"></div>
          </div>
        </el-card>
      </el-col>
      <!-- 热门课程排行 -->
      <el-col :span="16">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ $t('dashboard.popularCourses') }}</span>
          </div>
          <el-table :data="dashboardData.popularCourses" style="width: 100%">
            <el-table-column prop="course_name" :label="$t('dashboard.courseName')" width="180"></el-table-column>
            <el-table-column prop="course_type" :label="$t('dashboard.courseType')" width="120"></el-table-column>
            <el-table-column prop="booking_count" :label="$t('dashboard.bookingCount')" width="120"></el-table-column>
            <el-table-column prop="avg_rating" :label="$t('dashboard.averageRating')" width="120">
              <template slot-scope="scope">
                <el-rate
                  v-model="scope.row.avg_rating"
                  disabled
                  text-color="#ff9900"
                  score-template="{value}">
                </el-rate>
              </template>
            </el-table-column>
            <el-table-column prop="price" :label="$t('dashboard.price')" width="120">
              <template slot-scope="scope">
                ¥ {{ formatCurrency(scope.row.price) }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="8">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ $t('dashboard.technicianAvailability') }}</span>
          </div>
          <div class="technician-status-list">
            <div
              v-for="item in technicianStatuses"
              :key="item.coach_name"
              class="technician-status-item"
            >
              <div class="technician-header">
                <span class="technician-name">{{ item.coach_name }}</span>
                <el-tag :type="statusTagType(item.status)" size="mini">
                  {{ translateStatus(item.status) }}
                </el-tag>
              </div>
              <div class="next-booking" v-if="item.next_booking_time">
                {{ $t('dashboard.nextBooking') }}：{{ formatDateTime(item.next_booking_time) }}
              </div>
            </div>
            <div v-if="!technicianStatuses.length" class="empty-text">
              {{ $t('dashboard.noTechnicianStatus') }}
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ $t('dashboard.todayBookings') }}</span>
          </div>
          <el-table :data="todayBookings" size="mini" height="300">
            <el-table-column prop="coach_name" :label="$t('dashboard.coachName')" width="120" />
            <el-table-column prop="project_name" :label="$t('dashboard.projectName')" width="140" />
            <el-table-column prop="member_name" :label="$t('dashboard.memberName')" width="120" />
            <el-table-column prop="yuyueshijian" :label="$t('dashboard.bookingTime')" width="160">
              <template slot-scope="scope">
                {{ formatDateTime(scope.row.yuyueshijian) }}
              </template>
            </el-table-column>
            <el-table-column prop="price" :label="$t('dashboard.price')" width="100">
              <template slot-scope="scope">
                ¥ {{ formatCurrency(scope.row.price) }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ $t('dashboard.latestMembers') }}</span>
          </div>
          <ul class="latest-members-list">
            <li v-for="item in latestMembers" :key="item.zhanghao">
              <div class="member-name">{{ item.xingming || item.zhanghao }}</div>
              <div class="member-meta">
                {{ item.zhanghao }} · {{ item.shouji || '--' }}
              </div>
              <div class="member-meta">
                {{ formatDateTime(item.addtime) }}
              </div>
            </li>
          </ul>
          <div v-if="!latestMembers.length" class="empty-text">
            {{ $t('dashboard.noMembers') }}
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {
  getDashboardData,
  getMemberGrowthTrend,
  getBookingTrend,
  getMemberActivityDistribution,
  getCoachDailyBookings,
  getWeeklyProjectRevenue,
  getTechnicianAvailability,
  getTodayBookings,
  getLatestMembers
} from '@/api/statistics'

export default {
  name: 'Dashboard',
  data() {
    return {
      dashboardData: {},
      memberGrowthPeriod: 'month',
      bookingTrendPeriod: 'day',
      activityPeriod: 'month',
      memberGrowthChart: null,
      bookingTrendChart: null,
      memberActivityChart: null,
      coachBookingChart: null,
      projectRevenueChart: null,
      memberGrowthData: [],
      bookingTrendData: [],
      activityDistribution: [],
      coachBookings: [],
      weeklyProjectRevenue: [],
      technicianStatuses: [],
      todayBookings: [],
      latestMembers: []
    }
  },
  computed: {
    newMembersPercent() {
      const total = this.dashboardData.memberStats?.totalMembers || 0
      const newMembers = this.dashboardData.memberStats?.newMembers || 0
      return total > 0 ? ((newMembers / total) * 100).toFixed(2) : 0
    },
    incomeChangePercent() {
      // 这里假设后端返回了上月收入数据，实际使用时需调整
      return '+5.2' // 示例数据
    }
  },
  created() {
    this.fetchDashboardData()
  },
  mounted() {
    this.initCharts()
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
    if (this.memberGrowthChart) {
      this.memberGrowthChart.dispose()
    }
    if (this.bookingTrendChart) {
      this.bookingTrendChart.dispose()
    }
    if (this.memberActivityChart) {
      this.memberActivityChart.dispose()
    }
    if (this.coachBookingChart) {
      this.coachBookingChart.dispose()
    }
    if (this.projectRevenueChart) {
      this.projectRevenueChart.dispose()
    }
  },
  watch: {
    memberGrowthPeriod() {
      this.fetchMemberGrowthData()
    },
    bookingTrendPeriod() {
      this.fetchBookingTrendData()
    },
    activityPeriod() {
      this.fetchActivityDistribution()
    }
  },
  methods: {
    formatCurrency(value) {
      const number = Number(value)
      if (Number.isNaN(number)) return '0.00'
      return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    fetchDashboardData() {
      getDashboardData().then(response => {
        this.dashboardData = response.data
        // 初始获取各图表数据
        this.fetchMemberGrowthData()
        this.fetchBookingTrendData()
        this.fetchActivityDistribution()
        this.fetchCoachDailyBookings()
        this.fetchWeeklyProjectRevenue()
        this.fetchTechnicianAvailability()
        this.fetchTodayBookings()
        this.fetchLatestMembers()
      })
    },
    fetchMemberGrowthData() {
      getMemberGrowthTrend(this.memberGrowthPeriod, 12).then(response => {
        this.memberGrowthData = response.data.data
        this.updateMemberGrowthChart()
      })
    },
    fetchBookingTrendData() {
      const pointCountMap = {
        day: 24,
        week: 7,
        month: 6
      }
      const pointCount = pointCountMap[this.bookingTrendPeriod] || 12
      getBookingTrend(this.bookingTrendPeriod, pointCount).then(response => {
        this.bookingTrendData = response.data.data
        this.updateBookingTrendChart()
      })
    },
    fetchActivityDistribution() {
      getMemberActivityDistribution(this.activityPeriod).then(response => {
        this.activityDistribution = response.data.data
        this.updateMemberActivityChart()
      })
    },
    fetchCoachDailyBookings() {
      getCoachDailyBookings().then(response => {
        this.coachBookings = response.data.data || []
        this.updateCoachBookingChart()
      })
    },
    fetchWeeklyProjectRevenue() {
      getWeeklyProjectRevenue().then(response => {
        this.weeklyProjectRevenue = response.data.data || []
        this.updateProjectRevenueChart()
      })
    },
    fetchTechnicianAvailability() {
      getTechnicianAvailability().then(response => {
        this.technicianStatuses = response.data.data || []
      })
    },
    fetchTodayBookings(limit = 20) {
      getTodayBookings(limit).then(response => {
        this.todayBookings = response.data.data || []
      })
    },
    fetchLatestMembers(limit = 10) {
      getLatestMembers(limit).then(response => {
        this.latestMembers = response.data.data || []
      })
    },
    initCharts() {
      this.memberGrowthChart = echarts.init(this.$refs.memberGrowthChart)
      this.bookingTrendChart = echarts.init(this.$refs.bookingTrendChart)
      this.memberActivityChart = echarts.init(this.$refs.memberActivityChart)
      this.coachBookingChart = echarts.init(this.$refs.coachBookingChart)
      this.projectRevenueChart = echarts.init(this.$refs.projectRevenueChart)
      this.updateMemberGrowthChart()
      this.updateBookingTrendChart()
      this.updateMemberActivityChart()
      this.updateCoachBookingChart()
      this.updateProjectRevenueChart()
    },
    updateMemberGrowthChart() {
      if (!this.memberGrowthChart) return
      
      const xData = this.memberGrowthData.map(item => item.date_period)
      const newMemberData = this.memberGrowthData.map(item => item.new_members)
      const cumulativeData = this.memberGrowthData.map(item => item.cumulative_members)
      
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['新增会员', '累计会员']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData
        },
        yAxis: [
          {
            type: 'value',
            name: '新增会员',
            position: 'left'
          },
          {
            type: 'value',
            name: '累计会员',
            position: 'right'
          }
        ],
        series: [
          {
            name: '新增会员',
            type: 'bar',
            data: newMemberData
          },
          {
            name: '累计会员',
            type: 'line',
            yAxisIndex: 1,
            data: cumulativeData
          }
        ]
      }
      
      this.memberGrowthChart.setOption(option)
    },
    updateBookingTrendChart() {
      if (!this.bookingTrendChart) return
      
      const xData = this.bookingTrendData.map(item => item.label || item.date_period)
      const bookingData = this.bookingTrendData.map(item => Number(item.booking_count || 0))
      
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData
        },
        yAxis: {
          type: 'value',
          name: '预约数量'
        },
        series: [
          {
            name: '预约数量',
            type: 'line',
            smooth: true,
            data: bookingData,
            areaStyle: {}
          }
        ]
      }
      
      this.bookingTrendChart.setOption(option)
    },
    updateMemberActivityChart() {
      if (!this.memberActivityChart) return
      
      const activityLevels = this.activityDistribution.map(item => item.activity_level)
      const memberCounts = this.activityDistribution.map(item => item.member_count)
      
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 10,
          data: activityLevels
        },
        series: [
          {
            name: '会员活跃度',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: activityLevels.map((level, index) => ({
              value: memberCounts[index],
              name: level
            })),
            color: ['#91cc75', '#fac858', '#ee6666', '#73c0de']
          }
        ]
      }
      
      this.memberActivityChart.setOption(option)
    },
    updateCoachBookingChart() {
      if (!this.coachBookingChart) return
      const xData = this.coachBookings.map(item => item.coach_name)
      const yData = this.coachBookings.map(item => item.booking_count)
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: {
            interval: 0,
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t('dashboard.bookingCount')
        },
        series: [
          {
            type: 'bar',
            data: yData,
            itemStyle: {
              color: '#67C23A'
            }
          }
        ]
      }
      this.coachBookingChart.setOption(option)
    },
    updateProjectRevenueChart() {
      if (!this.projectRevenueChart) return
      const xData = this.weeklyProjectRevenue.map(item => item.project_name)
      const yData = this.weeklyProjectRevenue.map(item => Number(item.total_revenue || 0))
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            if (!params.length) return ''
            const item = params[0]
            return `${item.name}<br/>${this.$t('dashboard.revenue')}: ¥ ${this.formatCurrency(item.value)}`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: {
            interval: 0,
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t('dashboard.revenue')
        },
        series: [
          {
            type: 'bar',
            data: yData,
            itemStyle: {
              color: '#409EFF'
            }
          }
        ]
      }
      this.projectRevenueChart.setOption(option)
    },
    statusTagType(status) {
      switch ((status || '').toLowerCase()) {
        case 'busy':
          return 'danger'
        case 'available':
          return 'success'
        default:
          return 'info'
      }
    },
    translateStatus(status) {
      switch ((status || '').toLowerCase()) {
        case 'busy':
          return this.$t('dashboard.statusBusy')
        case 'available':
          return this.$t('dashboard.statusAvailable')
        case 'off':
        default:
          return this.$t('dashboard.statusOff')
      }
    },
    formatDateTime(value) {
      if (!value) return '--'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) {
        return value
      }
      const yyyy = date.getFullYear()
      const MM = (`0${date.getMonth() + 1}`).slice(-2)
      const dd = (`0${date.getDate()}`).slice(-2)
      const hh = (`0${date.getHours()}`).slice(-2)
      const mm = (`0${date.getMinutes()}`).slice(-2)
      return `${yyyy}-${MM}-${dd} ${hh}:${mm}`
    },
    resizeCharts() {
      if (this.memberGrowthChart) {
        this.memberGrowthChart.resize()
      }
      if (this.bookingTrendChart) {
        this.bookingTrendChart.resize()
      }
      if (this.memberActivityChart) {
        this.memberActivityChart.resize()
      }
      if (this.coachBookingChart) {
        this.coachBookingChart.resize()
      }
      if (this.projectRevenueChart) {
        this.projectRevenueChart.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 20px;

  /* 横向滚动样式 */
  .scroll-container {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* 平滑滚动 */
    scroll-behavior: smooth;
    
    .scroll-row {
      width: max-content; /* 让行宽度根据内容扩展 */
      min-width: 100%; /* 最小宽度为100% */
      flex-wrap: nowrap; /* 防止换行 */
      
      .el-col-6 {
        float: none; /* 清除浮动 */
        display: inline-block; /* 改为行内块显示 */
      }
    }
  }
  
  .stat-card {
    display: flex;
    align-items: center;
    
    .stat-icon {
      flex: 0 0 60px; /* 使用flex固定宽度，防止被挤压 */
      width: 60px;
      height: 60px;
      min-width: 60px; /* 添加最小宽度确保不被压缩 */
      min-height: 60px; /* 添加最小高度确保不被压缩 */
      border-radius: 50%;
      background-color: #409EFF;
      display: flex;
      align-items: center;
      justify-content: center;
      
      i {
        font-size: 30px;
        color: #fff;
      }
    }
    
    .stat-info {
      margin-left: 20px;
      flex: 1; /* 让info部分占据剩余空间 */
      min-width: 0; /* 防止文本溢出 */
      
      .stat-title {
        font-size: 14px;
        color: #606266;
        white-space: nowrap; /* 防止标题换行 */
        overflow: hidden;
        text-overflow: ellipsis;
      }
      
      .stat-value {
        font-size: 24px;
        font-weight: bold;
        margin: 5px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      
      .stat-desc {
        font-size: 12px;
        color: #909399;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  
  .chart-container {
    position: relative;
    width: 100%;
    height: 300px;
  }

  .technician-status-list {
    max-height: 300px;
    overflow-y: auto;
  }

  .technician-status-item {
    padding: 10px 0;
    border-bottom: 1px solid #f2f2f2;
  }

  .technician-status-item:last-child {
    border-bottom: none;
  }

  .technician-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }

  .technician-name {
    font-weight: 600;
    color: #303133;
  }

  .next-booking {
    font-size: 12px;
    color: #909399;
  }

  .latest-members-list {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 300px;
    overflow-y: auto;
  }

  .latest-members-list li {
    padding: 10px 0;
    border-bottom: 1px solid #f2f2f2;
  }

  .latest-members-list li:last-child {
    border-bottom: none;
  }

  .member-name {
    font-weight: 600;
    color: #303133;
  }

  .member-meta {
    font-size: 12px;
    color: #909399;
  }

  .empty-text {
    text-align: center;
    color: #909399;
    padding: 20px 0;
  }
}
</style> 